import { PromoRewardType, TPromoCodeSelect } from '@daymade/api-contracts';
import { Message } from 'semantic-ui-react';
import { formattedPriceStringFromPence } from 'utils/common';

export const renderReward = (currentPromo: TPromoCodeSelect) => {
  let text;
  const { rewardValue, rewardType, rewardCount } = currentPromo;

  switch (rewardType) {
    case PromoRewardType.FREE_ENTRY:
      return (
        <>
          <Message info>
            <Message.Header>Promo code successfully applied</Message.Header>
            <span style={{ fontWeight: 600 }}>
              Your random{' '}
              {rewardValue === 1 ? 'free entry is' : 'free entries are'} shown
              below:
            </span>
          </Message>
        </>
      );

    case PromoRewardType.DISCOUNT_PERCENTAGE:
      text = (
        <>
          Your promo code has successfully been applied. Your order has been
          discounted by {rewardValue}%
          {rewardCount && rewardCount > 0
            ? ` and will continue to be discounted for ${rewardCount} more week${
                rewardCount > 1 ? 's' : ''
              }`
            : ''}
          .
        </>
      );
      return (
        <>
          <Message info header={text} />
        </>
      );

    case PromoRewardType.DISCOUNT_ENTRY:
      text = (
        <>
          Your order has been discounted by the cost of{' '}
          {rewardValue === 1 ? 'an entry' : `${rewardValue} entries`}
          {rewardCount && rewardCount > 0
            ? ` and will continue to be discounted for ${rewardCount} more week${
                rewardCount > 1 ? 's' : ''
              }`
            : ''}
          .
        </>
      );
      return (
        <>
          <Message info header={text} />
        </>
      );
    case PromoRewardType.DISCOUNT_ENTRY_PERCENTAGE:
      text = (
        <>
          Your order has been discounted by {rewardValue}% of the cost of 1 entry
          {rewardCount && rewardCount > 0
            ? ` and will continue to be discounted for ${rewardCount} more week${
                rewardCount > 1 ? 's' : ''
              }`
            : ''}
          .
        </>
      );
      return (
        <>
          <Message info header={text} />
        </>
      );
    case PromoRewardType.FIXED_DISCOUNT:
      text = (
        <>
          Your order has been discounted by{' '}
          {formattedPriceStringFromPence(rewardValue)}
          {rewardCount && rewardCount > 0
            ? ` and will continue to be discounted for ${rewardCount} more week${
                rewardCount > 1 ? 's' : ''
              }`
            : ''}
          .
        </>
      );
      return (
        <>
          <Message info header={text} />
        </>
      );

    default:
      console.log(`Don't know what to do with rewardCode: ${rewardType}`);
  }
};
